import { Slide } from '@features/powerpoint';
import { BuildReportOptions } from '../../utils/build-presentation';
import { visibleSlide } from '@features/executive-report/slides';
import { coverSlide } from '@features/executive-report/slides/v2/cover';
import { audienceProfileSlide } from '@features/executive-report/slides/v2/audience-profile';
import { demographicProfileSlide } from '@features/executive-report/slides/v2/demographic-profile';
import { topStatesDmasLocationsSlide } from '@features/executive-report/slides/v2/top-states-dmas-locations';
import { moreStatsSlide } from '@features/executive-report/slides/v2/more-stats';
import { visitorProfileSlide } from '@features/executive-report/slides/v2/visitor-profile';
import {
  moreStatsSlideVisible,
  topStatesDmasLocationsSlideVisible,
  visitorProfileSlideVisible,
} from '../../domain/campaign-insights-slides';

export const campaignInsightsSlides = (
  campaignAnalyticsReport: BuildReportOptions['campaignAnalyticsReport'],
  includedSlides: BuildReportOptions['customFields']['includedSlides']['campaignInsights']
): Slide[] => {
  if (!campaignAnalyticsReport) return [];

  return [
    ...visibleSlide({
      slide: coverSlide('Campaign InSights'),
      visible: includedSlides.cover,
    }),
    ...visibleSlide({
      slide: audienceProfileSlide(campaignAnalyticsReport),
      visible:
        includedSlides.audienceProfile &&
        campaignAnalyticsReport.audienceProfile.visible,
    }),
    ...visibleSlide({
      slide: demographicProfileSlide(campaignAnalyticsReport),
      visible:
        includedSlides.demographicProfile &&
        campaignAnalyticsReport.demographicProfile.visible,
    }),
    ...visibleSlide({
      slide: topStatesDmasLocationsSlide(campaignAnalyticsReport),
      visible:
        includedSlides.topLocations &&
        topStatesDmasLocationsSlideVisible(campaignAnalyticsReport),
    }),
    ...visibleSlide({
      slide: moreStatsSlide(campaignAnalyticsReport),
      visible:
        includedSlides.moreStats &&
        moreStatsSlideVisible(campaignAnalyticsReport),
    }),
    ...visibleSlide({
      slide: visitorProfileSlide({ campaignAnalyticsReport }),
      visible:
        includedSlides.visitorProfile &&
        visitorProfileSlideVisible(campaignAnalyticsReport),
    }),
  ];
};
